// Use the lazy-loaded form builder
const lazyForm = (cb) =>
    import(/* webpackChunkName: "ddl-react-form" */ "./react-form").then(
        ({ default: initForm }) => cb(initForm)
    );

// If the current browser supports Intersection Observer, lazy load
// forms once they become visible. Otherwise initialize them straight away.
export default () => {
    const formElements = document.querySelectorAll("[data-schema-id]");
    if (formElements.length) {
        if ("IntersectionObserver" in window) {
            const io = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const node = entry.target;
                        lazyForm((initForm) => initForm(node));
                        // We only want this to fire once, so unobserve once we get here.
                        observer.unobserve(node);
                    }
                });
            });

            formElements.forEach((element) => io.observe(element));
        } else {
            lazyForm((initForm) => {
                formElements.forEach((formRoot) => initForm(formRoot));
            });
        }
    }
};
